<!--
  -  Copyright (c) Qwoach LLC 2022. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 2/1/2022
  -->

<template>
	<div>
		<qw-button @click="onPickFormClicked" :type="type">
			<slot>Pick a form</slot>
		</qw-button>
	</div>

</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import {createDialogLazy} from "@/utils/helpers-external";
let FormPickerDialog = () => import("@/core/components/Dialogs/PickerDilaog/FormPickerDialog.vue");

let formPickerDialog = createDialogLazy(FormPickerDialog)

export default {
	name: "FormPickerButton",
	components: {FormPickerDialog},
	extends: BaseComponent,

	props: {
		type: {String, default: "primary"},
	},

	methods: {
		async onPickFormClicked() {
			let res = await formPickerDialog()
			console.log("onPickFormClicked: res = ", res)
			if(res){
				this.$emit('formPicked', res)
			}
		}
	},
}
</script>

<style lang="scss">

</style>
